export default "__VITE_ASSET__mybBziHX__"